import React from "react";

import { List } from "@mui/material";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { SectionHeader } from "@src/components/Navigation/BaseSideNav/SectionHeader";
import { AdminRoutes } from "@src/components/Utils/routes";

interface AdminSectionProps {
  drawerOpen: boolean;
}

export const AdminSection = ({ drawerOpen }: AdminSectionProps) => {
  const isAdmin = useIsAdmin();
  const adminRoutes = AdminRoutes();

  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <SectionHeader title="Admin" drawerOpen={drawerOpen} />

      <List sx={{ px: drawerOpen ? 2 : 4, paddingTop: drawerOpen ? 0 : 2 }}>
        <IgListItemLink
          hasAccess={true}
          exact={true}
          drawerOpen={drawerOpen}
          Route={adminRoutes.admin}
        />
        <IgListItemLink
          hasAccess={true}
          drawerOpen={drawerOpen}
          Route={adminRoutes.ai}
          selectedAcceptedRoute="/ai/"
        />
        <IgListItemLink
          hasAccess={true}
          exact={true}
          drawerOpen={drawerOpen}
          Route={adminRoutes.performance}
        />
        <IgListItemLink
          hasAccess={true}
          drawerOpen={drawerOpen}
          Route={adminRoutes.configCompare}
        />
      </List>
    </>
  );
};
